import {
  SURNAMES,
  IMMIGRANT_SURNAMES,
  MALE_FIRST_NAMES,
  FEMALE_FIRST_NAMES,
  NEUTRAL_FIRST_NAMES,
} from './NameData';

// 全苗字を結合（通常 + 移住者用）
const ALL_SURNAMES = [...SURNAMES, ...IMMIGRANT_SURNAMES];

// 全名前を結合
const ALL_FIRST_NAMES = [...MALE_FIRST_NAMES, ...FEMALE_FIRST_NAMES, ...NEUTRAL_FIRST_NAMES];

/**
 * 名前から苗字を抽出
 */
export function extractLastName(fullName: string): string | null {
  const parts = fullName.trim().split(/\s+/);
  if (parts.length >= 2) {
    return parts[0]; // 最初の部分を苗字とする
  }
  return null; // スペースがない場合はnull（カタカナ名など）
}

/**
 * ランダムな名（ファーストネーム）のみを生成
 */
export function generateFirstName(): string {
  return ALL_FIRST_NAMES[Math.floor(Math.random() * ALL_FIRST_NAMES.length)];
}

/**
 * 日本風の名前を生成
 */
export function generateJapaneseName(): string {
  const lastName = ALL_SURNAMES[Math.floor(Math.random() * ALL_SURNAMES.length)];
  const firstName = generateFirstName();
  return `${lastName} ${firstName}`;
}

/**
 * 親の苗字を引き継いで子供の名前を生成
 * @param parent1Name 親1のフルネーム
 * @param parent2Name 親2のフルネーム
 * @returns 子供のフルネーム（親のどちらかの苗字 + ランダムな名前）
 */
export function generateChildName(parent1Name: string, parent2Name: string): string {
  // 両親の苗字を取得
  const lastName1 = extractLastName(parent1Name);
  const lastName2 = extractLastName(parent2Name);

  let childLastName: string;

  // 両方の親に苗字がある場合は50%でどちらかを選ぶ
  if (lastName1 && lastName2) {
    childLastName = Math.random() < 0.5 ? lastName1 : lastName2;
  } else if (lastName1) {
    childLastName = lastName1;
  } else if (lastName2) {
    childLastName = lastName2;
  } else {
    // どちらも苗字がない場合（カタカナ名同士など）はランダム
    return generateKatakanaName();
  }

  // 名前部分をランダム生成
  const firstName = generateFirstName();
  return `${childLastName} ${firstName}`;
}

/**
 * カタカナ風の名前を生成（ファンタジー風）
 */
export function generateKatakanaName(): string {
  const syllables = [
    'ア', 'イ', 'ウ', 'エ', 'オ',
    'カ', 'キ', 'ク', 'ケ', 'コ',
    'サ', 'シ', 'ス', 'セ', 'ソ',
    'タ', 'チ', 'ツ', 'テ', 'ト',
    'ナ', 'ニ', 'ヌ', 'ネ', 'ノ',
    'ハ', 'ヒ', 'フ', 'ヘ', 'ホ',
    'マ', 'ミ', 'ム', 'メ', 'モ',
    'ヤ', 'ユ', 'ヨ',
    'ラ', 'リ', 'ル', 'レ', 'ロ',
    'ワ', 'ン'
  ];

  const length = Math.floor(Math.random() * 3) + 2; // 2-4文字
  let name = '';
  for (let i = 0; i < length; i++) {
    name += syllables[Math.floor(Math.random() * syllables.length)];
  }

  return name;
}

/**
 * ミックス名（日本名 or カタカナ）をランダム生成
 */
export function generateRandomName(): string {
  // 70%で日本名、30%でカタカナ名
  return Math.random() < 0.7 ? generateJapaneseName() : generateKatakanaName();
}

/**
 * 名前の重複チェック付き生成
 */
export function generateUniqueName(existingNames: Set<string>): string {
  let name = generateRandomName();
  let attempts = 0;

  // 最大100回試行して重複を避ける
  while (existingNames.has(name) && attempts < 100) {
    name = generateRandomName();
    attempts++;
  }

  // それでも重複する場合は番号を付ける
  if (existingNames.has(name)) {
    let counter = 1;
    while (existingNames.has(`${name} ${counter}`)) {
      counter++;
    }
    name = `${name} ${counter}`;
  }

  return name;
}
